import { get } from "utils/helpers"

const getPropertyValue = (value, key) => {
  // Return 0 if no object key passed
  if (key === null && value === Object(value)) {
    return 0
  }

  const propertyValue = value === Object(value) ? get(value, key, null) : value

  if (typeof propertyValue === "string") {
    return propertyValue.toUpperCase()
  } else if (typeof propertyValue === "number") {
    return parseFloat(propertyValue).toFixed(2)
  } else {
    return propertyValue
  }
}

const compare = (order = "asc", key = null) => (a, b) => {
  const aValue = getPropertyValue(a, key)
  const bValue = getPropertyValue(b, key)

  let result = 0

  // Sorting Comparison
  //  - Checks for null values and sorts last
  //  - Checks if number and uses a natural sorting order
  //  - Checks values of strings and sorts appropriately
  if (!aValue) {
    result = 1
  } else if (!bValue) {
    result = -1
  } else if (aValue === bValue && a["id"] && b["id"]) {
    result = a["id"] - b["id"] // attemmpt to keep a strict order for equal items
  } else if (!isNaN(aValue) && !isNaN(bValue)) {
    result = aValue - bValue
  } else if (aValue < bValue) {
    result = -1
  } else if (aValue > bValue) {
    result = 1
  }

  return order === "asc" ? result : result * -1
}

const sortBy = (property, array, order = "asc") => array.sort(compare(order, property))

export { sortBy as default, compare }
